import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { GiftCardCatalog } from "@/components/gift-cards/catalog";
import { GiftCardError, GiftCardSkeleton } from "@/components/gift-cards/shared";
import { giftCardCatalogQuery, giftCardMeta, giftCardBrandSlug } from "@/lib/gift-cards";

export const Route = createFileRoute("/_site/gift-cards/$brand/")({
  validateSearch: (search: Record<string, unknown>) => ({ page: Number.isSafeInteger(Number(search.page)) && Number(search.page) > 0 ? Number(search.page) : undefined }),
  loader: ({ context }) => context.queryClient.ensureQueryData(giftCardCatalogQuery),
  head: ({ loaderData, params }) => giftCardMeta(undefined, loaderData?.find((card) => giftCardBrandSlug(card.brand) === params.brand)?.brand ?? params.brand),
  pendingComponent: GiftCardSkeleton,
  errorComponent: GiftCardError,
  notFoundComponent: GiftCardError,
  component: GiftCardBrand,
});
function GiftCardBrand() {
  const { brand } = Route.useParams();
  const { page = 1 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return <GiftCardCatalog brandSlug={brand} page={page} onPage={(next) => void navigate({ search: { page: next } })} />;
}
